import { Image, Modal } from "react-bootstrap"
import iconRecheck from '../img/icons/recheck.svg'

function ModalText({show, setShow, texto}){

    const handleClose = () => setShow(false)

    return(
        <Modal show={show} onHide={handleClose} centered className="border-0">
            <Modal.Body className="p-0">
                <div className="position-relative overflow-hidden h-100p">
                    <Image src={iconRecheck} fluid className="img-recheck"/>
                    <span className="mb-0 text-app-success" 
                        style={{
                            width: '75%',
                            display: 'block',
                            marginLeft: '110px'
                        }}>{texto}</span>
                </div>                
            </Modal.Body>
        </Modal>
    )

}
export default ModalText